/**
 * The modal's sections, in order. The value identifies and orders the step (currentStep); the sidebar bubble shows
 * its position among the steps shown instead, so values can be spaced out. A portfolio loan has one Property step per
 * property, numbered Property + 1, + 2, ... (see getPropertyStepNumber), so Repayments is well clear of them.
 */
export enum StandardLoanSection {
    SetupAndBorrower = 1,
    Loan = 2,
    Expenses = 3,
    PropertyRollup = 4,
    Property = 100,
    Repayments = 1000,
}

/** A portfolio loan's step for the property at this position (0-based): Property + 1, + 2, ... */
export const getPropertyStepNumber = (propertyIndex: number) => StandardLoanSection.Property + propertyIndex + 1;
